import React, { Component } from 'react';
import './Camera.css';
import CameraPhoto, { FACING_MODES, IMAGE_TYPES } from 'jslib-html5-camera-photo';
import SwitchIcon from './../../assets/images/switch-camera.png';
import BackIcon from './../../assets/images/back-arrow.png';
import ShutterSound from './../../assets/sound/camera-shutter.mp3';

class Camera extends Component {
    constructor(props, context) {
        super(props, context);
        this.cameraPhoto = null;
        this.videoRef = React.createRef();
        this.shutterSoundRef = React.createRef();
        this.state = {
            isPhotoCaptured: false,
            generatedImg: '',
            facingMode: FACING_MODES.USER,
            isLoading: false,
            mirrorOffset: true
        };

        // 3:4 ratio
        this.aspectRatio = {
            width : window.innerWidth ? window.innerWidth : window.screen.width,
            height : ((window.innerWidth ? window.innerWidth : window.screen.width)/3) * 4
        };
    }

    componentDidMount() {
        this._isMounted = true;
        this.cameraPhoto = new CameraPhoto(this.videoRef.current);
        this.startCamera(this.state.facingMode);
    }

    componentWillUnmount() {
        this._isMounted = false;
        this.cameraPhoto = null;
        this.resetState();
    }

    resetState = () => {
        this.setState({
            isPhotoCaptured: false,
            generatedImg: '',
            facingMode: FACING_MODES.USER,
            isLoading: false
        });
    }

    startCamera(idealFacingMode, idealResolution) {
        this.setState({ isLoading: true });
        this.cameraPhoto.startCamera(idealFacingMode, idealResolution)
            .then(() => {
                console.log('camera is started !');
                if (this._isMounted) {
                    this.setState({ isLoading: false });
                }
            })
            .catch((error) => {
                console.error('Camera not started!', error);
            });
    }

    // startCameraMaxResolution(idealFacingMode) {
    //     this.setState({ isLoading: true });
    //     this.cameraPhoto.startCameraMaxResolution(idealFacingMode)
    //         .then(() => {
    //             console.log('camera is started !');
    //             if (this._isMounted) {
    //                 this.setState({ isLoading: false });
    //             }
    //         })
    //         .catch((error) => {
    //             console.error('Camera not started!', error);
    //         });
    // }

    takePhoto = () => {
        this.setState({ isLoading: true });

        this.shutterSoundRef.current.play();

        const config = {
            sizeFactor: 1,
            imageType: IMAGE_TYPES.JPG,
            imageCompression: .95,
            isImageMirror: this.state.mirrorOffset
        };

        this.setState({ generatedImg: this.cameraPhoto.getDataUri(config), isPhotoCaptured: true });

        this.setState({ isLoading: false });
    }

    retake = () => {
        this.setState({ generatedImg: "", isPhotoCaptured: false });
    }

    stopCamera() {
        this.setState({ isLoading: true });
        this.cameraPhoto.stopCamera()
            .then(() => {
                console.log('Camera stopped!');
                if (this._isMounted) {
                    this.setState({ isLoading: false });
                }
            })
            .catch((error) => {
                console.log('No camera to stop!:', error);
            });
    }

    switchCamera = () => {
        this.setState({ isLoading: true });

        if (this.state.facingMode === FACING_MODES.USER) {
            this.setState({ facingMode: FACING_MODES.ENVIRONMENT, mirrorOffset: true });
            this.startCamera(this.state.facingMode);
        } else {
            this.setState({ facingMode: FACING_MODES.USER, mirrorOffset: false });
            this.startCamera(this.state.facingMode);
        }

        this.setState({ isLoading: false });
    }

    render() {
        const { closeCamera, filterImg, savePhoto } = this.props;
        const { generatedImg, isPhotoCaptured, isLoading, mirrorOffset } = this.state;

        return (
            <div>
                <audio className="sound-skid" preload="auto" ref={this.shutterSoundRef}>
                    <source src={ShutterSound}></source>
                </audio>
                <div className="camera-container">
                    <div>
                        <video
                            ref={this.videoRef}
                            autoPlay={true}
                            style={{ 
                                width: this.aspectRatio.width,
                                height: this.aspectRatio.height,
                                transform: mirrorOffset ? "rotateY(180deg)" : "rotateY(0deg)" 
                                }}></video>
                        {isPhotoCaptured && <>
                            <img src={generatedImg} style={this.aspectRatio} alt="Generated Selfie" />
                        </>}
                        <img src={filterImg} style={this.aspectRatio} alt="Filter Overlay" />
                    </div>
                    <div className="capture-controls">
                        {!isPhotoCaptured &&
                            <div>
                                <div className="capture-btn-container">
                                    <button className="capture-btn" onClick={this.takePhoto}></button>
                                </div>

                                <img src={SwitchIcon} className="switch-camera-btn" alt="Switch Icon" onClick={this.switchCamera} />
                                {!isPhotoCaptured &&
                                    <img src={BackIcon} className="go-back-btn" alt="Back Icon" onClick={() => {
                                        this.stopCamera();
                                        closeCamera();
                                    }} />}
                            </div>}
                        {isPhotoCaptured &&
                            <div className="retake-btn-container">
                                <button className="retake-btn" onClick={this.retake} >Take Another</button>
                                <button className="retake-btn" onClick={() => {
                                    savePhoto(generatedImg);
                                }} >Save Picture</button>
                            </div>}
                    </div>
                    {isLoading && <div className="loader"></div>}
                </div>
            </div>
        );
    }
}

export default Camera;